import { toursApi, cacheApi } from "@api";
import { BOOKING_SYSTEMS } from "@constants";
import {
    IProduct,
    IProductDetail,
    IProductSearchResponse,
    IServiceResult,
    ITourFare,
} from "@interfaces";
import { filterProducts } from "@utilities";
import { AxiosResponse } from "axios";

export const formatProductResponse = (detailTourRes: IProduct, id: string) => {
    let duringTime = "";
    if (Number(detailTourRes.durationDays) > 0) {
        duringTime += `${detailTourRes.durationDays} ${
            Number(detailTourRes.durationDays) === 1 ? "day" : "days"
        }`;
    }
    if (Number(detailTourRes.durationDays) > 0 && Number(detailTourRes.durationNight) > 0) {
        duringTime += " - ";
    }
    if (Number(detailTourRes.durationNight) > 0) {
        duringTime += `${detailTourRes.durationNight} ${
            Number(detailTourRes.durationNight) === 1 ? "night" : "nights"
        }`;
    }

    const description = [];
    const whatSIncluded = detailTourRes.includedItems.join(", ") || "";
    const bringItems = detailTourRes.bringItems.join(", ") || "";
    const descriptionContent = `
        ${
            detailTourRes.productDetails &&
            `<b>Description</b>: ${detailTourRes.productDetails}<br/>`
        }
        ${whatSIncluded && `<b>What's Included</b>: ${whatSIncluded}<br/>`}
        <b>Minimum Age</b>: ${detailTourRes?.minAgeRecommendation || 1} <br/>
        <b>Maximum Age</b>: ${detailTourRes?.maxAgeRecommendation || 99}<br/>
        <b>Fitness Requirement</b>: ${detailTourRes?.fitnessRequirement || "basic"} <br/>
        <b>Agent Restriction</b>: ${detailTourRes?.ageRestriction || 0} <br/>
        <b>Group Size</b>: ${detailTourRes?.minGroupSize || 1} - 
        ${detailTourRes?.maxGroupSize || 999} <br/>
        ${
            detailTourRes.operatingPartner &&
            `<b>Operating Partner</b>: ${detailTourRes.operatingPartner}<br/>`
        }
        ${
            detailTourRes.dietaryRequirement &&
            `<b>Dietary Requirements</b>: ${detailTourRes.dietaryRequirement}<br/>`
        }
        ${detailTourRes.luggageLimit && `<b>Luggage Limit</b>: ${detailTourRes.luggageLimit}<br/>`}
        ${bringItems && `<b>What To Bring</b>: ${bringItems}<br/>`} 
        ${
            detailTourRes.safePracticeMeasures &&
            `<b>Covid Safe Practises</b>: ${detailTourRes.safePracticeMeasures}<br/>`
        }
    `;
    description.push({
        title: "Description",
        content: descriptionContent,
    });
    description.push({
        title: "Itinerary",
        content:
            detailTourRes?.itineraryDescription
                ?.map((item: string, index: number) => {
                    const meals = detailTourRes?.itineraryMeals[index]?.split(", ") || [];
                    const isBreakfastChecked = meals.includes("Breakfast");
                    const isLunchChecked = meals.includes("Lunch");
                    const isDinnerChecked = meals.includes("Dinner");

                    return `
                    ${
                        detailTourRes?.itineraryTitle[index]
                            ? `
                        <b style="color: #898D8F; font-size: 14px;">Day ${index + 1}</b>
                        <br/>
                        <div style="display: flex; justify-content: space-between;">
                            <div>
                                <span>
                                    <span style="display: block; color:#131214; font-size: 18px; font-weight:600;">
                                        ${detailTourRes?.itineraryTitle[index]}
                                    </span>
                                </span>
                            </div>
                            <div style="margin: -30px 5px 0 0;">
                                <b style="color: #898D8F; font-size: 12px;">Meals</b><br/>
                                <div style="display: flex; gap: 8px; align-items: center;">
                                    <label>
                                        <img src="${isBreakfastChecked ? "/images/Checked.svg" : "/images/Checked-1.svg"}" alt="Checkbox"/>
                                    </label>
                                    <label>
                                        <img src="${isLunchChecked ? "/images/Checked.svg" : "/images/Checked-1.svg"}" alt="Checkbox"/>
                                    </label>
                                    <label>
                                        <img src="${isDinnerChecked ? "/images/Checked.svg" : "/images/Checked-1.svg"}" alt="Checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <span style="font-size: 14px; display: block;">${item}</span><br/><br/>
                    `
                            : "No Itinerary Provided"
                    }
                    `;
                })
                ?.join("") || "",
    });

    description.push({
        title: "Departures/Pickups",
        content: detailTourRes?.pickups || "",
    });
    description.push({
        title: "Extras",
        content: detailTourRes?.extras || "",
    });


    const faresPrices: ITourFare[] = detailTourRes.faresprices;
    // for await (const fare of detailTourRes.faresprices) {
    //     if (
    //         BOOKING_SYSTEMS.some((system) => system === fare.bookingSystem) &&
    //         fare.availabilityInfoUrl
    //     ) {
    //         const res = await toursApi.getBookingDetail(fare.productPricesDetailsId);
    //         faresPrices.push({ ...fare, ...res.data });
    //     } else {
    //         faresPrices.push({ ...fare });
    //     }
    // }

    // WHAT: Merge cancel policy for each fare
    const cancelPolicies: ITourFare[] = [];
    faresPrices.forEach((fare) => {
        if (cancelPolicies.length === 0) {
            cancelPolicies.push({ ...fare, fareName: `<b>${fare.fareName}</b> <br/>` });
        } else {
            let isSame = true;
            cancelPolicies.every((policy, index) => {
                if (!isSame) return false;
                const sameDescription =
                    policy.cancellationFeePolicyDescription ===
                    fare.cancellationFeePolicyDescription;
                let sameRule = false;

                // WHAT: check same all rule
                if (
                    // WHAT: different length return false
                    policy.cancellationFeeRules.length === fare.cancellationFeeRules.length
                ) {
                    sameRule = true;
                    // WHAT: check by index
                    for (let index = 0; index < policy.cancellationFeeRules.length; index++) {
                        const sameDate =
                            policy.cancellationFeeRules[index].daysBeforeTravelDate ===
                            fare.cancellationFeeRules[index].daysBeforeTravelDate;
                        const sameAmount =
                            policy.cancellationFeeRules[index].feeAmount ===
                            fare.cancellationFeeRules[index].feeAmount;
                        if (!sameDate || !sameAmount) {
                            // WHAT: return and break;
                            sameRule = false;
                            break;
                        }
                    }
                }
                isSame = sameDescription && sameRule;
                if (isSame) {
                    cancelPolicies[index].fareName += `<b>${fare.fareName}</b> <br/>`;
                }
            });

            if (!isSame) {
                if (
                    BOOKING_SYSTEMS.some((system) => system === fare.bookingSystem) &&
                    fare.availabilityInfoUrl
                ) {
                    cancelPolicies.push({
                        ...fare,
                        fareName: `<b>${fare.fareName}</b> <br/>`,
                    });
                }
            }
        }
    });
    if (cancelPolicies.length === 1) {
        cancelPolicies[0].fareName = "";
    }
    // WHAT: cancel policy for each fare
    let cancelPolicy = "";
    if (cancelPolicies.length > 0) {
        cancelPolicy = cancelPolicies.reduce((text, fare) => {
            const cancelFeeRule = fare.cancellationFeeRules.reduce((text, rule) => {
                return `${text} <li>- Cancelled within ${rule.daysBeforeTravelDate} days before travel: ${rule.feeAmount}% fee</li> `;
            }, "");

            if (!fare.cancellationFeePolicyDescription && cancelFeeRule.trim() === "") {
                return text;
            }

            return `${text} ${fare.fareName}
                <p>${fare.cancellationFeePolicyDescription || ""}</p>
                <ul>${cancelFeeRule}</ul> <br/>`;
        }, "");

        if (cancelPolicy.trim() !== "") {
            cancelPolicy =
                "<b>Please note any cancellation has a 10% cancellation processing fee PLUS the operator fee below.</b> <br/><br/>" +
                cancelPolicy;
        }
    }

    // always push, even if cancelPolicy = ""
    description.push({
        title: "Cancellation Policy",
        content: cancelPolicy || "",
    });
    return {
        isSuccess: true,
        data: {
            apiProviderId: detailTourRes.apiProviderId,
            groupFaresForAvailabilityCheck: detailTourRes.groupFaresForAvailabilityCheck,
            location: `${detailTourRes.categories.startLocationName}, ${detailTourRes.categories.countryNames[0]}`,
            name: detailTourRes.name,
            duration: duringTime,
            rrp: Number(detailTourRes.rrp),
            supplier: detailTourRes.supplierName,
            productId: id.toString(),
            productClass: detailTourRes.productClass,
            // Pass the raw duration fields through alongside the formatted
            // `duration` string so callers (e.g. the Trip Planner) can know
            // a "3 Day" tour spans 3 calendar days. Without these, the
            // formatted string is the only signal and consumers default to 1.
            durationDays: detailTourRes.durationDays,
            durationNight: detailTourRes.durationNight,
            tourCode: detailTourRes.tourCode,
            description,
            images: [],
            productImagePath: detailTourRes.productLargeSizeImagePath,
            faresPrices: faresPrices,
            supplierId: detailTourRes.supplierid,
            optionalFields: [],
            categories: detailTourRes.categories,
        },
    };
};

export const getProductHelper = async (
    id: string,
    skipMedia?: boolean,
): Promise<IServiceResult<IProductDetail | null>> => {
    try {
        const res = (await toursApi.getById(id)) as AxiosResponse<IProductSearchResponse>;
        const productResult = res.data.results.find((d) => d.productId.toString() === id);

        if (!productResult) {
            return { isSuccess: true, data: null };
        }

        const formattedProduct = formatProductResponse(productResult, id);

        if (skipMedia) {
            return {
                isSuccess: true,
                data: formattedProduct.data,
            };
        }

        const resMedia = await toursApi.getMediasById(id);
        return {
            isSuccess: true,
            data: {
                ...formattedProduct.data,
                images: resMedia.data.results,
            },
        };
    } catch (error) {
        console.error("Error fetching product:", error);
        return {
            isSuccess: false,
            errorMessage: "Failed to fetch product details",
            data: null,
        };
    }
};

export const getProductFromCache = async (
    id: string,
): Promise<IServiceResult<IProductDetail | null>> => {
    try {
        const cacheResp = await cacheApi.readProduct(id);
        const product = cacheResp.data?.data;
        if (product && product.productId && product.name) {
            const results = filterProducts([product]);
            if (results.length > 0) {
                const formattedProduct = formatProductResponse(results[0], id);
                return { isSuccess: true, data: formattedProduct.data };
            }
        }
        return { isSuccess: false, data: null };
    } catch {
        return { isSuccess: false, data: null };
    }
};

export const getProductImages = async (
    id: string,
): Promise<any[]> => {
    try {
        const resMedia = await toursApi.getMediasById(id);
        return resMedia.data.results ?? [];
    } catch {
        return [];
    }
};
